
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import NewVoteButton from '@/components/next/NewVoteButton.vue';
import { Icon, List } from 'vant';
import { vote, caseVote } from '../api';

Vue.use(Icon).use(List);
@Component({
  components: {
    SearchBar,
    NewVoteButton,
  },
})
export default class People extends Vue {
  @Prop({ default: 0 }) listNumber!: number;
  activity: number = 0;
  tab: any = [{ text: '经济人物' }, { text: '创新案例' }];
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  show: boolean = false;
  refreshing: boolean = false;
  search = '';
  placeholder: string = '请输入姓名或编号';
  voteName: string = '2022project/q2/2022economics_vote';
  voteNameCase: string = '2022project/q2/2022economics_case_vote';
  created() {
    setTimeout(() => {
      this.show = true;
    }, 50);
  }
  userInputChange(e: any) {
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 50);
    this.search = e;
    this.page = 1;
    this.list = [];
    this.loading = false;
    this.finished = false;
  }
  changeActivity(index: any) {
    this.show = false;
    if (index) {
      this.placeholder = '请输入案例名称或编号';
    } else {
      this.placeholder = '请输入姓名或编号';
    }
    setTimeout(() => {
      this.show = true;
    }, 50);
    this.activity = index;
    this.page = 1;
    this.list = [];
    this.loading = false;
    this.finished = false;
  }
  onLoad() {
    if (!this.activity) {
      vote(this.page, this.search).then((res: any) => {
        this.endListData(res);
      });
    } else {
      caseVote(this.page, this.search).then((res: any) => {
        this.endListData(res);
      });
    }
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  votSuccess(data: any, index: any) {
    this.list[index].votes = data;
  }
  onNavTo(url: string, id: number, index: number) {
    this.$routerThen
      .push({
        url: `${url}?id=${id}`,
      })
      .then((vm) => {
        vm.$on('like', (val: any) => {
          this.list[index].votes++;
        });
      });
  }
}
